import { useEffect, useMemo } from 'react';

import { OneSourceSyncConfig } from './one-source-sync-config';
import styles from './styles.module.less';
import { InventoryConnectionTerminusTypeEnum } from '../../../../../../../../../settings/inventory-sources/enums';
import { useInventorySyncContext } from '../../../../../../context/inventory-sync-context';

/**
 * @returns {React.JSX.Element} The inventory sync toggle component
 */
export const InventorySync = () => {
  const { sources, toggleConnection, selectedConnections } = useInventorySyncContext();

  // Always pre-select shipstationInventory as source
  useEffect(() => {
    const shipstationInventorySource = sources.find((source) => source.isShipstationInventory);
    if (shipstationInventorySource) {
      const isAlreadySelected = selectedConnections.some(
        (connection) =>
          connection.connectionId === shipstationInventorySource.connectionId &&
          connection.terminusType === InventoryConnectionTerminusTypeEnum.Source,
      );

      if (!isAlreadySelected) {
        toggleConnection(shipstationInventorySource.connectionId, InventoryConnectionTerminusTypeEnum.Source);
      }
    }
  }, [sources, selectedConnections, toggleConnection]);

  const content = useMemo(() => {
    if (sources.length > 0) {
      return <OneSourceSyncConfig />;
    }
    return null;
  }, [sources]);

  return (
    <div className={styles['inventory-setup-content']} data-testid='inventory-sync-container'>
      {content}
    </div>
  );
};
